import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2725">
      <div className="dark" data-id="element-2726">
        <Hero data-id="element-2727" />
      </div>
      <WhyUs data-id="element-2728" />
      <ByTheNumbers data-id="element-2729" />
      <Services data-id="element-2730" />
      <HowItWorks data-id="element-2731" />
      <FAQ data-id="element-2732" />
      <Reviews data-id="element-2733" />
      <CtaBanner data-id="element-2734" />
    </main>;
}